// sortable column
interface sortableColumnProps {
    element: HTMLElement,
    index: number
}
const compareValues = (a, b) => {
    // return -1/0/1 based on what you "know" a and b
    // are here. Numbers, text, some custom case-insensitive
    // and natural number ordering, etc. That's up to you.
    // A typical "do whatever JS would do" is:
    if (!isNaN(a) && !isNaN(b)) {
        // convert to numbers
        a = new Number(a);
        b = new Number(b);
    }
    return (a < b) ? -1 : (a > b) ? 1 : 0;
}

// Sortable table: allow sorting by column
//      table must has .table-sortable class
//      add data-toggle="sortable" to th to allow sorting on column

// To allow sorting to formatted values such as date or money
//      add real value to each td data-sortable-value="2020-03-06 18:35:29"
//      <td data-sortable-value="2020-02-01">01/02/2020</td>
//      <td data-sortable-value="12.56">$12.56</td>

export default class SortableTable {
    private table: HTMLTableElement;
    private sortableColumns: sortableColumnProps[] = []
    private tableBody: HTMLElement;

    constructor(table: HTMLTableElement) {
        this.table = table;
        this.tableBody = table.querySelector("tbody");

        // get sortable columns
        [].slice.call(this.table.querySelectorAll("thead th")).forEach((element: HTMLElement, index: number) => {
            if (element.getAttribute('data-toggle') === "sortable") {
                this.sortableColumns.push({ element, index });
            }
        });
    }

    init = () => {
        // click event: perform sorting
        this.sortableColumns.forEach(column => {
            column.element.addEventListener("click", (e) => {
                e.preventDefault();
                this._sorting(column);
            });
        });
    }

    private _sorting = (column: sortableColumnProps) => {
        let sortParamete = 0;
        let sortClass = "";
        // add sort state
        if (column.element.classList.contains("asc")) {
            // descending
            sortParamete = -1;
            column.element.classList.remove("asc");
            sortClass = "desc";
        } else {
            // ascending
            sortParamete = 1;
            column.element.classList.remove("desc");
            sortClass = "asc";
        }
        column.element.classList.add("sorting");
        // remove sort state from other column
        this.sortableColumns.forEach(otherColumn => {
            if (otherColumn.index != column.index) {
                otherColumn.element.classList.remove("asc", "desc");
            }
        });

        // cell query string
        let qs = `td:nth-child(${column.index + 1}`;

        // sorting
        // get all the rows in this table:
        let rows = Array.from(this.table.querySelectorAll('tbody tr'));
        rows.sort((r1, r2) => {
            // get each row's relevant column
            let value1 = this._tdValue(r1.querySelector(qs));
            let value2 = this._tdValue(r2.querySelector(qs));

            // and then effect sorting by comparing their content:
            return compareValues(value1, value2) * sortParamete;
        });
        setTimeout(() => {
            // clear tbody
            this.tableBody.innerHTML = "";
            // re-render rows
            this.tableBody.append(...rows);
            column.element.classList.remove("sorting");
        }, 0);
        column.element.classList.add(sortClass);
    }

    private _tdValue = (td: HTMLElement) => {
        let value = td.textContent.trim();

        // get data-sortable-value if possible
        const sortableValue = td.getAttribute("data-sortable-value");
        if (sortableValue && sortableValue.length > 0) {
            value = sortableValue;
        }
        return value;
    }
}